import React, { useEffect } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import {
    selectNotificationState,
    selectNotificationOptions,
    hideMessage
} from './NotiSlice';
import { useAppDispatch, useAppSelector } from '@/store/hook';

const NotificationHandler = () => {
    const dispatch = useAppDispatch();
    const notificationState = useAppSelector(selectNotificationState);
    const notificationOptions = useAppSelector(selectNotificationOptions);
    
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (notificationState && notificationOptions.message) {
            const { variant, message, autoHideDuration } = notificationOptions;

            enqueueSnackbar(message, {
                variant,
                autoHideDuration,
                onClose: () => dispatch(hideMessage()),
                onExited: () => dispatch(hideMessage()),
            });
        }
    }, [notificationState, notificationOptions, enqueueSnackbar, dispatch]);

    return null;
};

export const NotificationProvider = ({ children }) => {
    const notificationOptions = useAppSelector(selectNotificationOptions);

    return (
        <SnackbarProvider
            maxSnack={3}
            autoHideDuration={notificationOptions.autoHideDuration}
            anchorOrigin={notificationOptions.anchorOrigin}
            preventDuplicate={notificationOptions.preventDuplicate}
            dense={false}
        >
            <NotificationHandler />
            {children}
        </SnackbarProvider>
    );
};